import Subtract from './Subtract.svg';
import people_one from './people_one.webp';
import people_two from './people_two.webp';
import people_three from './people_three.webp';
import people_four from './people_four.webp';
import people_five from './people_five.webp';
import people_six from './people_six.webp';
import close from './close.svg';
import video from './video.svg';
import aboutUs from './aboutUs.webp';
import aboutUs_logo from './aboutUs_logo.svg';
import SubtractFooter from './SubtractFooter.svg';
import Instagram from './Instagram.svg';
import Facebook from './Facebook.svg';
import Youtube from './Youtube.svg';
import aboutUsDesk from './aboutUsDesk.png';
import aboutTablet from './aboutTablet.png';

export default {
  aboutTablet,
  Subtract,
  people_one,
  people_two,
  people_three,
  people_four,
  people_five,
  people_six,
  close,
  video,
  aboutUs,
  aboutUs_logo,
  SubtractFooter,
  Instagram,
  Facebook,
  Youtube,
  aboutUsDesk,
};
